import * as angular from "angular";
import * as _ from "lodash";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class AuthenticationAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }


  // RESET PASSWORD //
  resetPasswordSuccess() {
    const message = {
      body: 'AUTHENTICATION_RESET_PASSWORD_SUCCESS',
      details: 'AUTHENTICATION_RESET_PASSWORD_SUCCESS_DETAILS'
    };
    return this.bringozToastService.success(message, null, 'Login')
  }

  resetPasswordError(error?) {
    const message = {
      body: 'AUTHENTICATION_RESET_PASSWORD_ERROR',
      message: undefined
    };
    if (error?.code === 400212) {
      message.message = 'PASSWORD_TOO_SHORT'
    }
    return this.bringozToastService.error(message, {minimum: _.get(error, 'more_info')});
  }

  // SIGNUP //
  signupSuccess() {
    const message = {
      body: 'AUTHENTICATION_SIGNUP_SUCCESS',
      details: 'AUTHENTICATION_SIGNUP_SUCCESS_DETAILS'
    };
    return this.bringozToastService.success(message)
  }

  signupError() {
    const message = {
      body: 'AUTHENTICATION_SIGNUP_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // LOGIN //
  loginError() {
    const message = {
      body: 'AUTHENTICATION_LOGIN_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message, null, 'Forgot password')
  }

  loginErrorExcessiveFailedAttempts(timeToWait) {
    const message = {
      body: 'YOUR_ACCOUNT_HAS_BEEN_TEMPORARILY_LOCKED_FOR_X_MINUTES',
      details: 'AUTHENTICATION_LOGIN_ERROR'
    };
    return this.bringozToastService.error(message, {minutes: timeToWait}, 'Forgot password')
  }


}

angular
  .module('bringoz.admin.authentication')
  .service('authenticationAlertsService', AuthenticationAlertsService);
